import React from "react";

interface Props {
    size?: number,
    color?: string,
}

const SvgFacebook = ({size = 16, color = '#FFF'}: Props) => (
    <svg width={size} height={size} viewBox="0 0 16 16">
        <path
            fill={color}
            d="M8.765 5.5v-2a1 1 0 011-1h1V0h-2a3 3 0 00-3 3v2.5h-2V8h2v8h3V8h2l1-2.5h-3z"
        />
    </svg>
);

export default SvgFacebook;